import React from "react";

const STATUS_MAP: Record<string, { label: string; icon: string; cls: string }> = {
  created:    { label: "Creata",       icon: "🟡", cls: "badge-warning" },
  collecting: { label: "Raccolta dati", icon: "🔵", cls: "badge-info" },
  compiled:   { label: "Compilato",    icon: "📝", cls: "badge-neutral" },
  signing:    { label: "In firma",     icon: "✍️", cls: "badge-info" },
  signed:     { label: "Firmato",      icon: "✅", cls: "badge-success" },
  failed:     { label: "Fallita",      icon: "❌", cls: "badge-danger" },
};

interface Props {
  status: string;
}

export function StatusBadge({ status }: Props) {
  const info = STATUS_MAP[status] || { label: status, icon: "⚪", cls: "badge-neutral" };
  return (
    <span className={`badge ${info.cls}`}>
      {info.icon} {info.label}
    </span>
  );
}
